// src/components/home/FinalCTA.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaRocket, FaProductHunt, FaCheckCircle, FaMagic } from "react-icons/fa";
import "./FinalCTA.css";

const FinalCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="bvh-final-cta-section" data-aos="zoom-in">
      <div className="bvh-final-cta-card">
        <span className="bvh-cta-pill-tag">
          <FaMagic style={{ color: "#4f46e5" }} /> Join the V2 Beta Era
        </span>

        <h2 className="bvh-final-cta-title">
          Ready to Experience Smarter Learning?
        </h2>
        <p className="bvh-final-cta-desc">
          Join thousands of students, developers, and educators preparing with BodhAI V2 Beta today.
        </p>

        <div className="bvh-cta-features-strip">
          <span className="bvh-cta-feature-chip">
            <FaCheckCircle style={{ color: "#16a34a" }} /> Free to Use
          </span>
          <span className="bvh-cta-feature-chip">
            <FaCheckCircle style={{ color: "#16a34a" }} /> Instant Code Evaluation
          </span>
          <span className="bvh-cta-feature-chip">
            <FaCheckCircle style={{ color: "#16a34a" }} /> AI Test Generator
          </span>
        </div>

        <div className="bvh-final-cta-actions">
          <button className="bvh-final-cta-btn light" onClick={() => navigate("/register")}>
            <FaRocket style={{ fontSize: "1.1rem" }} /> Start Learning
          </button>

          <a
            href="https://www.producthunt.com/products/bodhai?utm_source=bodhai.pages.dev&utm_medium=referral&utm_campaign=bodhai_product_launch_july_2026&utm_content=visit_producthunt_from_bodhai_homepage&utm_term=ai_learning_tool_launch"
            target="_blank"
            rel="noopener noreferrer"
            className="bvh-final-cta-btn ph"
          >
            <FaProductHunt style={{ color: "#ffffff", fontSize: "1.2rem" }} /> Support on Product Hunt
          </a>
        </div>
      </div>
    </section>
  );
};

export default React.memo(FinalCTA);
